// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"a4d669d8","563":"24a35a01","748":"cacf1b52","787":"f46be9fc","931":"7cd19638"}[chunkId] + ".chunk.js";
};